import request from '@/utils/request'


// 根据医院和档案ID获取检查报告列表
export function getTerm(data) {
    return request({
        url: '/api/report/page/term',
        method: 'get',
        params: data,
    })
}


// 获取单个检查报告详情 hospitalId  id 
export function getCheck(data) {
    return request({
        url: '/api/report/check',
        method: 'get',
        params: data,
    })
}


// 获取单个检验报告详情 hospitalId  id 
export function getTest(data) {
    return request({
        url: '/api/report/test',
        method: 'get',
        params: data,
    })
}


// 获取体检检查报告详情 hospitalId  recordId   phyid  reportId 
export function getDetail(data) {
    return request({
        url: '/api/report/health/detail',
        method: 'get',
        params: data,
    })
}

// 获取细菌培养报告详情 
export function getCulture(data) {
    return request({
        url: '/api/report/culture',
        method: 'get',
        params: data,
    })
}

// 获取药敏试验报告详情 
export function getChemosens(data) {
    return request({
        url: '/api/report/chemosens',
        method: 'get',
        params: data,
    })
}

// 查询对比报告列表
export function getContrastReportList (data) {
  return request({
      url: '/api/v2/report/getContrastReportList',
      method: 'POST',
      data,
  })
}

// 查询对比报告详情
export function getContrastReportDetail (data) {
  return request({
      url: '/api/v2/report/getContrastReportDetail',
      method: 'POST',
      data,
  })
}












